import { Button as MantineButton, type ButtonProps as MantineButtonProps } from "@mantine/core";
import type { ReactElement, ReactNode } from "react";
import clsx from "clsx";
import styles from "../Button.module.scss";

export type TextButtonProps = {
  children?: ReactNode;
  isDisabled?: boolean;
  iconLeft?: ReactElement;
  variant?: "text-primary" | "text-secondary" | "text-destructive-primary";
  size?: "small" | "base";
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
} & Omit<MantineButtonProps, "variant" | "size">;

export function TextButton(props: TextButtonProps) {
  const {
    variant = "text-primary",
    size = "base",
    isDisabled,
    children,
    iconLeft,
    ...rest
  } = props;

  const finalClassName = isDisabled
    ? clsx(styles["button-text-disabled"], styles["base-button"], styles[`button-text-${size}`])
    : clsx(styles[`button-${variant}`], styles["base-button"], styles[`button-text-${size}`]);

  return (
    <MantineButton
      className={finalClassName}
      variant="subtle"
      disabled={isDisabled}
      {...rest}
      type="button"
    >
      {iconLeft && <span className={styles["icon-left"]}>{iconLeft}</span>}
      {children}
    </MantineButton>
  );
}
